const queue: Array<() => void> = [];
let flushing = false;

function flushQueue() {
  flushing = false;
  const batch = queue.splice(0, 3);
  batch.forEach((run) => run());
  if (queue.length > 0) {
    flushing = true;
    requestAnimationFrame(flushQueue);
  }
}

/** Spread heavy card mounts across animation frames to avoid main-thread freezes. */
export function scheduleStaggeredMount(run: () => void) {
  queue.push(run);
  if (!flushing) {
    flushing = true;
    requestAnimationFrame(flushQueue);
  }
}
